export const dom = {
  tracksPanel: null,
  trackActions: null,
  dynamicActions: null,
  tracksList: null,
  tripsList: null,
  boatsList: null,
  errorDisplay: null,
  errorButton: null,
  errorMessage: null,
  uploadForm: null,
  uploadUI: null,
  uploadCancelButton: null,
  uploadFileInput: null,
  uploadSubmitButton: null,
  uploadStoreInput: null,
  loadingMessage: null,
  header: null,
  legendTitle: null,
  legendDate: null,
  legendDistance: null,
  legendDuration: null,
  legendJourneyTimes: null,
  legendTopSpeed: null,
  legendAverageSpeed: null,
  legendWeatherDescription: null,
  legendWeatherTemperature: null,
  legendWeatherWindspeed: null,
  legendWeatherWindDirection: null,
  legendDescriptionContainer: null,
  legendDescriptionText: null,
  deleteConfirmModal: null,
  deleteConfirmMessage: null,
  deleteConfirmButton: null,
  deleteCancelButton: null,
  deletePointConfirmModal: null,
  deletePointConfirmMessage: null,
  deletePointConfirmButton: null,
  deletePointCancelButton: null,
  trimConfirmModal: null,
  trimConfirmMessage: null,
  trimConfirmButton: null,
  trimCancelButton: null,
  fileNameDisplay: null,
  appContent: null,
  loadingOverlay: null,
  loginModal: null,
  authControls: null,
  userInfoDisplay: null,
  userAvatar: null,
  logoutButton: null,
  toggleLegendButton: null,
  toggleTracksButton: null,
  shareTrackButton: null,
  editTrackButton: null,
  savingIndicator: null,
  singleTrackView: null,
  multiTrackView: null,
  mapContainer: null,
  
  tabs: null,
  tabContents: null,
  boatFormModal: null,
  boatForm: null,
  boatFormTitle: null,
  uploadTrackBtn: null,
  addBoatBtn: null,
  bulkPhotoUploadBtn: null,
  bulkPhotoInput: null,
  boatSelectorContainer: null,
  boatSelectorIcon: null,
  personModal: null,
  personPicture: null,
  personName: null,
  personEmail: null,
  apiKeyDisplay: null,
  getApiKeyBtn: null,
  copyApiKeyBtn: null,
  rotateApiKeyBtn: null,
  closePersonModalBtn: null,
  rotateKeyConfirmModal: null,
  rotateKeyConfirmButton: null,
  rotateKeyCancelButton: null,
  shareModal: null,
  shareUrlInput: null,
  copyShareUrlBtn: null,
  closeShareModalBtn: null,
  addPhotoBtn: null,
  photoUploadInput: null,
  bulkUploadProgressModal: null,
  bulkUploadProgressMsg: null,
  bulkUploadResultModal: null,
  bulkUploadResults: null,
  bulkUploadOkBtn: null,
  photoModal: null,
  photoModalImage: null,
  photoModalSpinner: null,
  photoModalCloseBtn: null,
  photoModalDeleteBtn: null,
  photoModalCaption: null,
  legendActions: null,
  toggleMarkersBtn: null,
  exportBtn: null,
  boatAgentBtn: null,
  boatAgentConfirmModal: null,
  boatAgentConfirmBtn: null,
  boatAgentCancelBtn: null,
  agentLoadingModal: null,
  boatViewModal: null,
  boatViewDetails: null,
  editBoatBtn: null,
  landingPageContainer: null,

  // Getting Started Modal
  gettingStartedModal: null,
  gsUploadTrackBtn: null,
  gsAddBoatBtn: null,
  gsCloseBtn: null,

  // Crew Modal
  crewModal: null,
  crewTabs: null,
  crewTabContents: null,
  crewList: null,
  addCrewForm: null,
  addCrewTypeRadios: null,
  crewEmailInput: null,
  crewNameInput: null,
  crewRoleInput: null,
  closeCrewModalBtn: null,
  searchModeGroup: null,
  guestModeGroup: null,

  // Edit Crew Role Modal
  editCrewRoleModal: null,
  editCrewRoleForm: null,
  editCrewTrackId: null,
  editCrewMemberId: null,
  editCrewMemberName: null,
  editCrewRoleInput: null,

  // Credential Modal
  credentialModal: null,
  credTabs: null,
  credTabContents: null,
  credentialList: null,
  courseList: null,
  credFormContainer: null,
  credFormTitle: null,
  credForm: null,
  credIdInput: null,
  credKindInput: null,
  credOrgInput: null,
  credNameInput: null,
  credNumberInput: null,
  credIssueDateInput: null,
  credExpiryDateInput: null,
  credNotesInput: null,
  credOrgDatalist: null,
  credNameDatalist: null,
  closeCredModalBtn: null,

  // Import Modal elements
  importUI: null,
  importForm: null,
  importFileInput: null,
  importFileNameDisplay: null,
  importSubmitButton: null,
  importLoadingMsg: null,
  importResult: null,
  importOkBtn: null,

  // Admin Dashboard elements
  inviteForm: null,
  invitationsList: null,
  usersList: null,
};

export function cacheDomElements() {
  dom.tracksPanel = document.querySelector(".tracks-panel");
  dom.trackActions = document.querySelector(".track-actions");
  dom.dynamicActions = document.querySelector(".dynamic-actions");
  dom.tracksList = document.querySelector(".tracks-list");
  dom.tripsList = document.querySelector(".trips-list");
  dom.boatsList = document.querySelector(".boats-list");
  dom.errorDisplay = document.querySelector(".error");
  dom.errorButton = document.querySelector(".error button");
  dom.errorMessage = document.querySelector(".error .message");
  dom.uploadForm = document.querySelector("form");
  dom.uploadUI = document.querySelector(".upload-ui");
  dom.uploadCancelButton = document.querySelector(".upload-ui button.cancel");
  dom.uploadFileInput = document.querySelector(".upload-ui input[type=file]");
  dom.uploadSubmitButton = document.querySelector(".upload");
  dom.uploadStoreInput = document.querySelector(".upload-store");
  dom.loadingMessage = document.querySelector(".loading-message");
  dom.header = document.querySelector("header");
  dom.legendTitle = document.querySelector(".title");
  dom.legendDate = document.querySelector(".stat-value.date");
  dom.legendDistance = document.querySelector(".stat-value.distance");
  dom.legendDuration = document.querySelector(".stat-value.duration");
  dom.legendJourneyTimes = document.querySelector(".stat-value.journey-times");
  dom.legendTopSpeed = document.querySelector(".stat-value.top-speed");
  dom.legendAverageSpeed = document.querySelector(".stat-value.avg-speed");
  dom.legendWeatherDescription = document.querySelector(".weather-item.description");
  dom.legendWeatherTemperature = document.querySelector(".weather-item.temperature");
  dom.legendWeatherWindspeed = document.querySelector(".weather-item.wind-speed");
  dom.legendWeatherWindDirection = document.querySelector(".weather-item.wind-direction");
  dom.legendDescriptionContainer = document.querySelector(".description-container");
  dom.legendDescriptionText = document.querySelector("p.description");
  dom.deleteConfirmModal = document.querySelector(".delete-confirm");
  dom.deleteConfirmMessage = document.querySelector(".delete-confirm .message");
  dom.deleteConfirmButton = document.querySelector(".delete-confirm .confirm");
  dom.deleteCancelButton = document.querySelector(".delete-confirm .cancel");
  dom.deletePointConfirmModal = document.querySelector(".delete-point-confirm");
  dom.deletePointConfirmMessage = document.querySelector(".delete-point-confirm .message");
  dom.deletePointConfirmButton = document.querySelector(".delete-point-confirm .confirm");
  dom.deletePointCancelButton = document.querySelector(".delete-point-confirm .cancel");
  dom.trimConfirmModal = document.querySelector(".trim-confirm");
  dom.trimConfirmMessage = document.querySelector(".trim-confirm .message");
  dom.trimConfirmButton = document.querySelector(".trim-confirm .confirm");
  dom.trimCancelButton = document.querySelector(".trim-confirm .cancel");
  dom.fileNameDisplay = document.querySelector(".file-name");
  dom.appContent = document.querySelector(".app-content");
  dom.loadingOverlay = document.querySelector(".loading-overlay");
  dom.loginModal = document.querySelector(".login-modal");
  dom.authControls = document.querySelector(".auth-controls");
  dom.userInfoDisplay = document.querySelector(".user-info");
  dom.adminControls = document.querySelector(".admin-controls");
  dom.userAvatar = document.querySelector(".user-avatar");
  dom.logoutButton = document.querySelector(".logout-btn");
  dom.toggleLegendButton = document.querySelector(".toggle-legend-btn");
  dom.toggleTracksButton = document.getElementById("toggle-tracks-btn");
  dom.shareTrackButton = document.querySelector(".share-track-btn");
  dom.editTrackButton = document.querySelector(".edit-track-btn");
  dom.savingIndicator = document.querySelector(".saving-indicator");
  dom.singleTrackView = document.querySelector(".single-track-view");
  dom.multiTrackView = document.querySelector(".multi-track-view");
  dom.mapContainer = document.getElementById("map");
  dom.tabs = document.querySelectorAll('.tab-button');
  dom.tabContents = document.querySelectorAll('.tab-content');
  dom.boatFormModal = document.querySelector('.boat-form-modal');
  dom.boatForm = document.getElementById('boat-form');
  dom.boatFormTitle = document.querySelector('.boat-form-modal .modal-title');
  dom.boatSelectorContainer = document.querySelector('.boat-selector-container');
  dom.boatSelectorIcon = document.querySelector('.boat-selector-container .boat-icon');
  dom.personModal = document.querySelector('.person-modal');
  dom.personName = document.getElementById('person-name');
  dom.editPersonNameBtn = document.getElementById('edit-person-name-btn');
  dom.personNameViewMode = document.querySelector('.person-field-group .view-mode');
  dom.personNameEditMode = document.querySelector('.person-field-group .edit-mode');
  dom.personNameInput = document.getElementById('person-name-input');
  dom.savePersonNameBtn = document.getElementById('save-person-name-btn');
  dom.cancelPersonNameBtn = document.getElementById('cancel-person-name-btn');
  dom.personEmail = document.getElementById('person-email');
  dom.apiKeyDisplay = document.getElementById('api-key-display');
  dom.getApiKeyBtn = document.getElementById('get-api-key-btn');
  dom.copyApiKeyBtn = document.getElementById('copy-api-key-btn');
  dom.rotateApiKeyBtn = document.getElementById('rotate-api-key-btn');
  dom.closePersonModalBtn = document.querySelector('.close-person-modal-btn');
  dom.rotateKeyConfirmModal = document.querySelector('.rotate-key-confirm');
  dom.rotateKeyConfirmButton = document.querySelector('.rotate-key-confirm .confirm');
  dom.rotateKeyCancelButton = document.querySelector('.rotate-key-confirm .cancel');
  dom.personPicture = document.getElementById('person-picture');
  dom.shareModal = document.querySelector('.share-modal');
  dom.shareUrlInput = document.querySelector('.share-url');
  dom.copyShareUrlBtn = document.querySelector('.copy-share-url-btn');
  dom.closeShareModalBtn = document.querySelector('.close-share-modal-btn');
  dom.addPhotoBtn = document.querySelector('.add-photo-btn');
  dom.photoUploadInput = document.getElementById('photo-upload-input');
  dom.bulkUploadProgressModal = document.querySelector('.bulk-upload-progress-modal');
  dom.bulkUploadProgressMsg = dom.bulkUploadProgressModal ? dom.bulkUploadProgressModal.querySelector('.upload-progress-msg') : null;
  dom.bulkUploadResultModal = document.querySelector('.bulk-upload-result-modal');
  dom.bulkUploadResults = document.querySelector('.bulk-upload-result-modal .bulk-upload-results');
  dom.bulkUploadOkBtn = document.querySelector('.bulk-upload-result-modal .bulk-upload-ok-btn');
  dom.photoModal = document.getElementById('photo-modal');
  if (dom.photoModal) {
    dom.photoModalImage = dom.photoModal.querySelector('img');
    dom.photoModalCloseBtn = dom.photoModal.querySelector('.close-button');
    dom.photoModalDeleteBtn = dom.photoModal.querySelector('#delete-photo-btn');
    dom.photoModalCaption = dom.photoModal.querySelector('.photo-caption');
    dom.photoModalSpinner = dom.photoModal.querySelector('.spinner');
  }
  dom.legendActions = document.querySelector('.legend-actions');
  dom.toggleMarkersBtn = document.getElementById('toggle-markers-btn');
  dom.exportBtn = document.getElementById('export-png-btn');
  dom.boatAgentBtn = document.getElementById('boat-agent-btn');
  dom.boatAgentConfirmModal = document.querySelector('.boat-agent-confirm-modal');
  dom.boatAgentConfirmBtn = document.querySelector('.boat-agent-confirm-modal .confirm');
  dom.boatAgentCancelBtn = document.querySelector('.boat-agent-confirm-modal .cancel');
  dom.agentLoadingModal = document.querySelector('.agent-loading-modal');
  dom.boatViewModal = document.querySelector('.boat-view-modal');
  dom.boatViewDetails = document.querySelector('.boat-view-modal .boat-details');
  dom.editBoatBtn = document.getElementById('edit-boat-btn');
  dom.landingPageContainer = document.getElementById('landing-page-container');

  // Getting Started Modal
  dom.gettingStartedModal = document.querySelector('.getting-started-modal');
  dom.gsUploadTrackBtn = document.getElementById('gs-upload-track');
  dom.gsAddBoatBtn = document.getElementById('gs-add-boat');
  dom.gsCloseBtn = document.querySelector('.close-getting-started-btn');

  // Crew Modal
  dom.crewModal = document.querySelector('.crew-modal');
  dom.crewTabs = document.querySelectorAll('.crew-tab-button');
  dom.crewTabContents = document.querySelectorAll('.crew-tab-content');
  dom.crewList = document.querySelector('.crew-list');
  dom.addCrewForm = document.getElementById('add-crew-form');
  dom.addCrewTypeRadios = document.querySelectorAll('input[name="add-crew-type"]');
  dom.crewEmailInput = document.getElementById('crew-email');
  dom.crewNameInput = document.getElementById('crew-name');
  dom.crewRoleInput = document.getElementById('crew-role');
  dom.closeCrewModalBtn = document.querySelector('.close-crew-modal-btn');
  dom.searchModeGroup = document.querySelector('.form-group.search-mode');
  dom.guestModeGroup = document.querySelector('.form-group.guest-mode');

  // Edit Crew Role Modal
  dom.editCrewRoleModal = document.querySelector('.edit-crew-role-modal');
  dom.editCrewRoleForm = document.getElementById('edit-crew-role-form');
  dom.editCrewTrackId = document.getElementById('edit-crew-track-id');
  dom.editCrewMemberId = document.getElementById('edit-crew-member-id');
  dom.editCrewMemberName = document.getElementById('edit-crew-member-name');
  dom.editCrewRoleInput = document.getElementById('edit-crew-role-input');

  // Credential Modal
  dom.credentialModal = document.querySelector('.credential-modal');
  dom.credTabs = document.querySelectorAll('.cred-tab-button');
  dom.credTabContents = document.querySelectorAll('.cred-tab-content');
  dom.credentialList = document.querySelector('.credential-list');
  dom.courseList = document.querySelector('.course-list');
  dom.credFormContainer = document.querySelector('.cred-form-container');
  dom.credFormTitle = document.querySelector('.cred-form-title');
  dom.credForm = document.getElementById('cred-form');
  dom.credIdInput = document.getElementById('cred-id');
  dom.credKindInput = document.getElementById('cred-kind');
  dom.credOrgInput = document.getElementById('cred-organization');
  dom.credNameInput = document.getElementById('cred-name-input');
  dom.credNumberInput = document.getElementById('cred-number');
  dom.credIssueDateInput = document.getElementById('cred-issue-date');
  dom.credExpiryDateInput = document.getElementById('cred-expiry-date');
  dom.credNotesInput = document.getElementById('cred-notes');
  dom.credOrgDatalist = document.getElementById('cred-org-list');
  dom.credNameDatalist = document.getElementById('cred-name-list');
  dom.closeCredModalBtn = document.querySelector('.close-cred-modal-btn');

  // Import Modal elements
  dom.importUI = document.querySelector('.import-ui');
  dom.importForm = document.getElementById('import-form');
  dom.importFileInput = document.getElementById('import-file-upload');
  dom.importFileNameDisplay = document.querySelector('.import-file-name');
  dom.importSubmitButton = document.querySelector('.import-submit');
  dom.importLoadingMsg = document.querySelector('.import-loading-message');
  dom.importResult = document.querySelector('.import-result');
  dom.importOkBtn = document.querySelector('.import-ok-btn');

  // Admin Dashboard elements
  dom.inviteForm = document.getElementById('invite-form');
  dom.invitationsList = document.getElementById('invitations-list');
  dom.usersList = document.getElementById('users-list');
}
